export default "__VITE_ASSET__D8iCt4it__"